<app-metadata [graphName]="'company-employment'"></app-metadata>
@if (data && helptexts &&informations) {
  <div>
    <app-form
      [informations]="informations"
      [data]="data"
      [helptexts]="helptexts[0]"
      (dataSubmitted)="onData($event)"
    ></app-form>
  </div>
}
